import React from 'react';
import {Avatar} from "primereact/avatar";
import { T } from 'services/lang/LanguageService';
import {useGetUserInfo} from "api/api-hooks/user-hooks";
import DynamicTooltip from "../dynamic-tooltip/DynamicTooltip";
import {getColorForString, getInitials} from "../../../utils/utils";
import useSafeId from "../../../hooks/dashboard/useDashboardComponentId";

interface IUserAvatarProps {
    username: string;
    tooltip?: string;
}

export default function UserAvatar({username, tooltip}: IUserAvatarProps) {
    const query = useGetUserInfo(username, {enabled: !!username});

    const avatarColors = getColorForString(username);

    const id = useSafeId();

    return <>
        {query.isLoading && T("word.loading")}

        {query.isError && T("word.error")}

        {query.isSuccess &&
        query.data ?
            <>
                <Avatar id={id}
                        className="mr-2"
                        shape="circle"
                        label={getInitials(query.data.displayName)}
                        style={{backgroundColor: avatarColors.bgColor, color: avatarColors.color}}
                />
                <DynamicTooltip target={`#${id}`} data={ [tooltip ?? query.data.displayName]}/>
            </>
            :
            "N/A"
        }
    </>
}